import React from "react";
import { ArrowRight, Star } from "lucide-react";
import { HERO_IMAGE, BRAND } from "@/lib/brand";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 md:pt-36 pb-20 md:pb-28 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 fade-up">
          <div className="flex items-center gap-3 mb-8">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  size={14}
                  className="fill-[#B37C7C] text-[#B37C7C]"
                />
              ))}
            </div>
            <span className="text-xs uppercase tracking-[0.22em] text-[#B37C7C] font-medium">
              5.0 · Aubrey, Texas
            </span>
          </div>

          <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] text-[#362C2C] mb-8">
            Custom cookies
            <span className="block italic font-accent-serif text-[#B37C7C] mt-2">
              baked with love in Aubrey.
            </span>
          </h1>

          <p className="text-[#5C5252] text-base md:text-lg leading-relaxed max-w-xl mb-10">
            Hand-rolled, hand-iced, and made to make you smile. Every cookie from our
            little Texas studio is designed just for you — birthdays, showers, holidays,
            and everything in between.
          </p>

          <div className="flex flex-wrap items-center gap-4">
            <a
              href="#order"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center gap-2 bg-[#B37C7C] text-white px-7 py-3.5 rounded-md hover:bg-[#9A6565] hover:-translate-y-0.5 hover:shadow-lg shadow-[#B37C7C]/20 transition-all duration-300 tracking-wide text-sm"
            >
              Request a Quote
              <ArrowRight
                size={16}
                className="group-hover:translate-x-1 transition-transform duration-300"
              />
            </a>
            <a
              href="#designer"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center gap-2 border border-[#B37C7C] text-[#B37C7C] px-7 py-3.5 rounded-md hover:bg-[#F7EBEB] transition-all duration-300 tracking-wide text-sm"
            >
              Try the AI Designer
            </a>
          </div>

          <div className="mt-14 flex items-center gap-8 text-xs uppercase tracking-[0.22em] text-[#5C5252]">
            <div>
              <div className="text-[#362C2C] font-serif-display text-2xl normal-case tracking-normal">
                200+
              </div>
              <span>Happy orders</span>
            </div>
            <div className="w-px h-10 bg-[#EFE8E8]" />
            <div>
              <div className="text-[#362C2C] font-serif-display text-2xl normal-case tracking-normal">
                Aubrey
              </div>
              <span>Texas</span>
            </div>
            <div className="hidden sm:block w-px h-10 bg-[#EFE8E8]" />
            <div className="hidden sm:block">
              <div className="text-[#362C2C] font-serif-display text-2xl normal-case tracking-normal">
                5.0 ★
              </div>
              <span>On Google</span>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 relative fade-up-delay-2">
          <div className="relative rounded-lg overflow-hidden aspect-[4/5] md:aspect-[5/6]">
            <img
              src={HERO_IMAGE}
              alt="Elegant sugar cookies on linen"
              className="w-full h-full object-cover"
              data-testid="hero-image"
            />
            <div className="absolute bottom-6 left-6 right-6 md:bottom-8 md:left-8 md:right-auto md:max-w-xs bg-white/80 backdrop-blur-xl border border-white/60 rounded-md p-5 soft-float">
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#B37C7C] mb-2">
                Spooky Season
              </div>
              <div className="font-serif-display text-xl text-[#362C2C] leading-snug">
                Halloween boxes & Bags of Boos — now taking orders.
              </div>
            </div>
          </div>
          <div className="absolute -z-10 -inset-6 md:-inset-10 bg-[#F7EBEB] rounded-lg" />
        </div>
      </div>
    </section>
  );
}
